import Swiper from "swiper/bundle";
export default function careersJs() {
	var careerTabTrigger = new Swiper(".careerTabTrigger", {
		spaceBetween: 11,
		slidesPerView: "auto",
		freeMode: true,
		watchSlidesProgress: true,
	});
	var careerTabContent = new Swiper(".careerTabContent", {
		autoHeight: true,
		slidesPerView: 1,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		thumbs: {
			swiper: careerTabTrigger,
		},
	});
}
